import { render, staticRenderFns } from "./account-actions.vue?vue&type=template&id=b32ff02a&scoped=true"
import script from "./account-actions.vue?vue&type=script&lang=js"
export * from "./account-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32ff02a",
  null
  
)

export default component.exports